export default __webpack_public_path__ + "static/media/404.c9e5e23a.png";